import { ApiError } from "../api/types";

/**
 * Parses backend error response and returns a user-friendly error message.
 * Handles both field-specific errors and general message errors.
 */
export function parseBackendError(
  result: ApiError,
  field: string,
  defaultMessage: string,
): string {
  if (result.error?.[field]?.[0]) {
    return result.error[field][0];
  }
  return result.message || defaultMessage;
}
